module.exports = __webpack_public_path__ + "img/webforms.b985de68.png";